import Image from "next/image";

export default function FramesMint() {
  return (
    <div className="min-h-screen bg-[#17101F]">
      <div className="w-full flex flex-col items-center py-20">
        <a
          href="https://warpcast.com/thirdweb/0xf1239ee6"
          rel="noopener noreferrer"
        >
          <Image
            src="/farcaster.png"
            height={266}
            width={266}
            alt="farcaster"
          />
        </a>
        <h1 className="font-bold text-4xl mt-9 text-center text-white">
          Farcaster x thirdweb
        </h1>
        <h1 className="font-medium mt-6 text-center text-white">
          Learn how to build your own farcaster frame with thirdweb engine{" "}
          <a
            href="https://blog.thirdweb.com/create-an-nft-mint-farcaster-frame/"
            target="_blank"
            className="text-violet-400 underline"
            rel="noopener noreferrer"
          >
            here
          </a>
        </h1>
      </div>
    </div>
  );
}
